var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTinyStar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8897 10.9699C32.0097 13.0899 32.0097 16.5299 29.8897 18.6499L24.5597 23.9799C22.4397 26.0999 18.9997 26.0999 16.8797 23.9799L11.5597 18.6599C9.43973 16.5399 9.43973 13.0999 11.5597 10.9799C13.6797 8.85988 17.1197 8.85988 19.2397 10.9799L20.7197 12.4599L22.2097 10.9699C24.3297 8.84988 27.7697 8.84988 29.8897 10.9699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8304 1.11C21.8304 0.496964 21.3334 0 20.7204 0C20.1073 0 19.6104 0.496964 19.6104 1.11V4.22C19.6104 4.83304 20.1073 5.33 20.7204 5.33C21.3334 5.33 21.8304 4.83304 21.8304 4.22V1.11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8304 31.8903C21.8304 31.2772 21.3334 30.7803 20.7204 30.7803C20.1073 30.7803 19.6104 31.2772 19.6104 31.8903V35.0003C19.6104 35.6133 20.1073 36.1103 20.7204 36.1103C21.3334 36.1103 21.8304 35.6133 21.8304 35.0003V31.8903Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3304 19.1702C40.9435 19.1702 41.4404 18.6732 41.4404 18.0602C41.4404 17.4472 40.9435 16.9502 40.3304 16.9502H37.2204C36.6074 16.9502 36.1104 17.4472 36.1104 18.0602C36.1104 18.6732 36.6074 19.1702 37.2204 19.1702H40.3304Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22008 19.1702C4.83311 19.1702 5.33008 18.6732 5.33008 18.0602C5.33008 17.4472 4.83311 16.9502 4.22008 16.9502H1.11008C0.497042 16.9502 7.9155e-05 17.4472 7.9155e-05 18.0602C7.9155e-05 18.6732 0.497042 19.1702 1.11008 19.1702H4.22008Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6062 5.73455C35.0397 5.30106 35.0397 4.59825 34.6062 4.16477C34.1727 3.73129 33.4699 3.73129 33.0364 4.16477L32.2798 4.92138C31.8463 5.35486 31.8463 6.05767 32.2798 6.49115C32.7133 6.92463 33.4161 6.92463 33.8496 6.49115L34.6062 5.73455Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16868 31.1847C9.60216 30.7513 9.60216 30.0484 9.16868 29.615C8.7352 29.1815 8.03238 29.1815 7.5989 29.615L6.8423 30.3716C6.40881 30.8051 6.40882 31.5079 6.8423 31.9413C7.27578 32.3748 7.97859 32.3748 8.41207 31.9413L9.16868 31.1847Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0467 31.9372C33.4802 32.3707 34.183 32.3707 34.6165 31.9372C35.05 31.5037 35.05 30.8009 34.6165 30.3675L33.8599 29.6109C33.4264 29.1774 32.7236 29.1774 32.2901 29.6108C31.8566 30.0443 31.8566 30.7471 32.2901 31.1806L33.0467 31.9372Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59455 6.49778C8.02804 6.93126 8.73085 6.93126 9.16433 6.49778C9.59781 6.0643 9.59781 5.36148 9.16433 4.928L8.40773 4.1714C7.97424 3.73792 7.27143 3.73792 6.83795 4.1714C6.40447 4.60488 6.40447 5.30769 6.83795 5.74117L7.59455 6.49778Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyStar);
export default __webpack_public_path__ + "static/media/tiny-star.9bfde0d24c01991c466d0de42140a7c8.svg";
export { ForwardRef as ReactComponent };